import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRoughInclusions = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M27.5 5 43 27.5 35 43H12.5L5 20 16.11 5zm-10 3-9 12.5L15 40h18l6.5-12.227L26 8zm-1.82 7.318.416 5.141 4.285 7.156-.427-4.735zm9.202-1.215 2.224 1.851-3.444.528-2.052-1.668zM21.09 37.415l-.012-2.894-2.647-2.049.04 2.643zm11.603-11.07a.75.75 0 1 0 .438-1.434.75.75 0 0 0-.438 1.435m-2.889-1.667a.75.75 0 1 1-1.434-.438.75.75 0 0 1 1.434.438m-.309 8.89a.75.75 0 1 0 .634-1.36.75.75 0 0 0-.634 1.36m-2.628-2.053a.75.75 0 1 1-1.36-.634.75.75 0 0 1 1.36.634" })
});
export default SvgRoughInclusions;
